import React from 'react'

import { useTranslation } from 'language/translator'

import Icon from 'components_new/atoms/Icon'
import Switch from 'components_new/atoms/Switch'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

interface FeaturesProps {
  imageExport: boolean
  setImageExport: (value: boolean) => void
  setUserFilter: (value: boolean) => void
  userFilter: boolean
}

const Features = (props: FeaturesProps) => {
  const { imageExport, setImageExport, setUserFilter, userFilter } = props

  const { t } = useTranslation()

  return (
    <SettingsGroup title={t('dashboards', 'functionality_label')}>
      <SettingsItem
        actions={
          <Switch
            color="success"
            checked={userFilter}
            onChange={() => setUserFilter(!userFilter)}
            size="medium"
          />
        }
        body={t('dashboards', 'user_filter_description')}
        icon={<Icon name={'Filter'} />}
        title={t('dashboards', 'user_filter_label')}
        titleAdornments={<code>?filter=true</code>}
      />

      <SettingsItem
        actions={
          <Switch
            color="success"
            checked={imageExport}
            onChange={() => setImageExport(!imageExport)}
            size="medium"
          />
        }
        body={t('dashboards', 'image_export_description')}
        icon={<Icon name={'Download'} />}
        title={t('dashboards', 'image_export_label')}
        titleAdornments={<code>?export=true</code>}
      />
    </SettingsGroup>
  )
}

export default Features
